<template>
  <div class="home">
    <head-com></head-com>
    <div class="main">
      <div class="cont bs">
        <h3 class="title">个人信息</h3>
        <el-form class="info" ref="dataForm" :model="dataForm" :rules="rules" label-width="150px">
          <el-form-item label="本人登记照片：" ref="empHeadportrait" prop="empHeadportrait">
            <el-upload
              class="avatar-uploader"
              accept=".jpg, .jpeg, .jif, .png"
              :action="uploadUrl"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess"
              :on-progress="handleProgress"
            >
              <img v-if="dataForm.empHeadportrait" :src="dataForm.empHeadportrait" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <!-- <div slot="tip" class="el-upload__tip">请上传jpg, gif, png格式的图片, 建议图片大小不超过2M，比例为1:1</div> -->
              <div slot="tip" class="el-upload__tip">
                <h3>请上传符合要求的头像照片，否则证书记录将无效：</h3>
                <p>（1）本人近三个月内的正面、免冠、无妆、彩色（限白底色）电子登记照；</p>
                <p>（2）照片类型为jpg、png格式，照片大小不超过80K；</p>
                <p>（3）照片须显示双耳、双眉、双肩；</p>
                <p>（4）不得上传全身照、半身照、风景照、生活照等；</p>
                <p>（5）不得进行过度PS处理，不得美颜；</p>
                <p>（6）不得佩戴首饰、头饰。</p>
              </div>
            </el-upload>
          </el-form-item>
          <div class="line cl">
            <el-form-item class="fl" label="姓名：" prop="empName">
              <el-input v-model="dataForm.empName" placeholder="请输入姓名" clearable></el-input>
            </el-form-item>
            <el-form-item class="sex fl" label="性别：" prop="empSex">
              <el-radio v-model="dataForm.empSex" label="0">男</el-radio>
              <el-radio v-model="dataForm.empSex" label="1">女</el-radio>
            </el-form-item>
          </div>
          <div class="line">
            <el-form-item label="身份证号：" prop="empIdcard">
              <el-input v-model="dataForm.empIdcard" placeholder="请输入身份证号" clearable disabled></el-input>
            </el-form-item>
            <el-form-item label="企业名称：">
              <el-input v-model="dataForm.affiliatedEnterprise" placeholder="请输入企业名称" clearable></el-input>
            </el-form-item>
          </div>
          <div class="line">
            <el-form-item label="手机号：" prop="empTel">
              <el-input v-model="dataForm.empTel" placeholder="请输入手机号" clearable></el-input>
            </el-form-item>
            <el-form-item label="选择专业：">
              <el-select v-model="dataForm.postId" placeholder="请选择专业" multiple disabled>
                <el-option
                  v-for="(item,i) in specialList"
                  :key="i"
                  :label="item.postName"
                  :value="item.postId"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item class="create">
            <el-button type="primary" size="small" @click="update('dataForm')">修改</el-button>
            <el-button size="small" @click="cancel">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <footer-com></footer-com>
  </div>
</template>

<script>
import HeadCom from "@/components/Header.vue";
import FooterCom from "@/components/Footer.vue";
import http from "../api/module";
import { bizURL } from "../api/baseUrl";

export default {
  name: "personal",
  data() {
    return {
      specialList: JSON.parse(sessionStorage.getItem("specialList")),
      uploadUrl: bizURL + "/employee/uploadImage",
      dataForm: {
        empHeadportrait: '',
        empName: '',
        empSex: '',
        empIdcard: '',
        affiliatedEnterprise: '',
        postId: [],
        postName: []
      },
      rules: {
        empHeadportrait: [{ required: true, message: "请上传本人证件照片", trigger: "click" }],
        empName: [{ required: true, message: "请输入姓名！", trigger: "blur" }],
        empSex: [{ required: true, message: "请选择性别！", trigger: "blur" }],
        empTel: [{ required: true, message: "请输入手机号！", trigger: "blur" }],
      }
    };
  },
  components: {
    HeadCom,
    FooterCom
  },
  mounted() {
    this.userInfo();
  },
  methods: {
    userInfo() {
      http
        .getUserInfo()
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.dataForm = data.data.data;
            var postId = this.dataForm.postId;
            this.dataForm.postId = this.dataForm.postName.split(",");
            // this.dataForm.postId = this.dataForm.postId.split(",").map(item=>{
            //   return item*1;
            // });
            // this.dataForm.postId = [261,269,271];
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败，请联系管理员！"
          });
        });
    },
    cancel() {
      this.userInfo();
    },
    beforeAvatarUpload(file) {
      const isLt80k = file.size / 1024 < 80;
      if (!isLt80k) {
        this.$message.warning({
          duration: 1000,
          message: "上传图片大小不能超过 80k！"
        });
      }
      return isLt80k;
    },
    handleProgress(event, file, fileList) {
      // console.log(file, "handleProgress");
    },
    // 获取上传图片路径
    handleAvatarSuccess(res, file, fileList) {
      this.dataForm.empHeadportrait = res.data;
      this.$refs.empHeadportrait.clearValidate();
    },
    // 修改个人信息
    update(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          http
            .updateInfo({
              empHeadportrait: this.dataForm.empHeadportrait,
              empName: this.dataForm.empName,
              empSex: this.dataForm.empSex,
              empIdcard: this.dataForm.empIdcard,
              affiliatedEnterprise: this.dataForm.affiliatedEnterprise,
              empTel: this.dataForm.empTel
              // postId: this.postId
            })
            .then(data => {
              if (data.data.code == "200" || data.data.success == true) {
                this.$message.success({
                  duration: 1000,
                  message: "修改成功,请重新登录！"
                });
                setTimeout(()=>{
                  this.$router.push({
                    path: '/login'
                  })
                },1000)
              } else {
                this.$message.error({
                  duration: 1000,
                  message: data.data.message
                });
              }
            })
            .catch(error => {
              this.$message.error({
                duration: 1000,
                message: "请求失败，请联系管理员！"
              });
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.avatar-uploader {
  width: 90%;
  height: 190px !important;
}
.avatar-uploader-icon {
  width: 130px;
  height: 190px;
  line-height: 190px;
}
/deep/.el-upload.el-upload--text{
  width: 130px;
  height: 190px;
}

.avatar {
  width: 100%;
  height: auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}

.el-icon-plus.avatar-uploader-icon {
  line-height: 190px;
}
.el-upload__tip {
  top: 92% !important;
  margin-left: 10px;
  p {
    line-height: 24px;
  }
}
.cont {
  border-radius: 6px;
  width: 100%;
  margin: 20px 0;
  background: #ffffff;
  .title {
    font-size: 18px;
    line-height: 60px;
    border-bottom: 1px solid #ddd;
    padding: 0 20px;
    font-weight: normal;
  }
}
.info {
  padding: 30px 150px;
  /deep/.el-form-item__label {
    font-size: 16px;
  }
  .line {
    .sex {
      /deep/.el-radio {
        width: 20%;
        float: left;
      }
    }
    /deep/.el-form-item {
      width: 44%;
      // float: left;
      display: inline-block;
      margin-right: 50px;
    }
    /deep/.el-form-item__label {
      font-size: 16px;
    }
    /deep/.el-select {
      width: 100%;
    }
  }
  .create {
    display: block;
    /deep/.el-form-item__content {
      text-align: center;
      margin-top: 30px;
      margin-left: 0 !important;
    }
  }
}
</style>
